import { useUserMsgStore } from "@/stores/user/useUserMsgStore";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "../Icon";
import styles from "./index.module.scss";

type MessageIconProps = {
  count?: number;
  size?: string;
  className?: string;
};

export const MessageIcon = (props: MessageIconProps) => {
  const msgStore = useUserMsgStore();
  const navigate = useNavigate();
  useEffect(() => {
    msgStore.fetchUnreadCount();
  }, []);
  return (
    <div
      className={`${props.className || ""} ${styles.user_notice}`}
      onClick={() => navigate("/messages/msg")}
    >
      <Icon
        name={msgStore.unReadCount ? "notice" : "non-notice"}
        size={props.size || "24px"}
        className={styles.notice_icon}
      />
      {msgStore.unReadCount ? (
        <div className={styles.user_notice_num}>{msgStore.unReadCount}</div>
      ) : null}
    </div>
  );
};
